import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getModuleList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  if (!str) return ""
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const ModulesList = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    const data = await getModuleList()
    setIsLoading(false)

    const grouped = {}

    data?.data?.forEach(item => {
      const groupName = item?.submodules?.name || "Others"
      if (!grouped[groupName]) grouped[groupName] = []

      grouped[groupName].push({
        label: ucfirst(item.name),
        value: item.id,
        raw: item, // keep original for advanced filtering
      })
    })

    const groupedOptions = Object.entries(grouped).map(
      ([groupLabel, options]) => ({
        label: ucfirst(groupLabel),
        options,
      })
    )

    setFetchResponse(groupedOptions)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  // Custom filtering — applied per option in grouped structure
  const customFilterOption = (candidate, input) => {
    const label = candidate.label?.toLowerCase()
    const submoduleName = candidate.data?.raw?.submodules?.name?.toLowerCase()
    const inputValue = input.toLowerCase()

    return (
      label?.includes(inputValue) ||
      submoduleName?.includes(inputValue)
    )
  }

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={fetchResponse}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"}
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            onChange={e => {
              onChange(e)
              if (onSelectChange) onSelectChange(e)
            }}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            filterOption={customFilterOption}
          />
        )}
      />
    </div>
  )
}

export default ModulesList
